import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";
import { APIError } from "../../../core/types";
import { ErrorMessageManager } from "../../../core/http/ErrorMessageManager";

export const useSmsRegistration = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { password, phoneNumber, token, isActivation } = state ?? {};

  useEffect(() => {
    if (!phoneNumber || !token) return navigateToPage(PageRoutes.LOGIN);
  }, [phoneNumber, token]);

  const handleSmsRegistration = useCallback((otp: string) => {
    dispatch(appActions.showLoading());

    if (isActivation) {
      dispatch(
        authActions.updateLoginCredentials.started({
          otp,
          password,
          phone_number: phoneNumber,
          activation_token: token,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: ({ success }) => {
            if (success) {
              navigateToPage(PageRoutes.SMS_REGISTRATION_COMPLETE, false, {
                isActivation,
              });
            }
          },
          onError: (error: APIError | undefined) => {
            const errorMessage: string =
              ErrorMessageManager.Instance.getErrorMessage(
                error?.response?.data["error-code"]
                  ? error?.response?.data["error-code"]
                  : "unauthorized",
              );
            dispatch(
              appActions.showModal({
                title: errorMessage,
                buttons: [
                  {
                    variant: "dark",
                    text: "閉じる",
                    onClick: () => {
                      dispatch(appActions.hideModal());
                    },
                  },
                ],
              }),
            );
          },
        }),
      );
    } else {
      dispatch(
        authActions.verifyPhoneNumber.started({
          otp,
          session_token: token,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: ({ access_token, is_fido_registered }) => {
            navigateToPage(PageRoutes.SMS_REGISTRATION_COMPLETE, false, {
              accessToken: access_token,
              isFidoRegistered: is_fido_registered,
            });
          },
          onError: (error: APIError | undefined) => {
            const errorMessage: string =
              ErrorMessageManager.Instance.getErrorMessage(
                error?.response?.data["error-code"]
                  ? error?.response?.data["error-code"]
                  : "unauthorized",
              );
            dispatch(
              appActions.showModal({
                title: errorMessage,
                buttons: [
                  {
                    variant: "dark",
                    text: "閉じる",
                    onClick: () => {
                      dispatch(appActions.hideModal());
                    },
                  },
                ],
              }),
            );
          },
        }),
      );
    }
  }, []);

  const handleResendSms = useCallback(() => {
    navigateToPage(PageRoutes.SMS_SEND, false, {
      phoneNumber,
      token,
      isActivation,
    });
  }, []);

  return { handleSmsRegistration, handleResendSms };
};
